<template>
    <div :class="{'fixed_page':showJc}">
        <div class="header">
            <div class="header-inner">
                <van-icon name="arrow-left" class="left-icon" @click="$router.go(-1)" />
                <div class="search">
                    <input v-model="inputValue" type="text" class="search_ipt"
                        ref="search_ipt" placeholder="请输入想搜的游戏">
                    <i class="clear" @click="cleaript" v-if="showclear"></i>
                    <button class="search_btn" @click="getSearch">搜索</button>
                </div>
            </div>
        </div>
        <div class="market_area">
            <!-- 常用 -->
            <div class="common" v-if="bindapps.length > 0">
                <p class="tit">常用({{bindapps.length}})</p>
                <swiper class="common_swiper" :options="swiperOption">
                    <swiper-slide v-for="(item,i) in bindapps" :key="i">
                        <div class="common_swiper_item" @click="gotoHome(item.app_name,item.icon,item.id,item.prop_trade,item.role_trade)">
                            <van-image class="icon" :src="item.icon" />
                            <p>{{ item.app_name }}</p>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>

            <van-tabs v-model="active" @click="changeTab" line-width="1.5rem">
                <van-tab name="all" title="全部"></van-tab>
                <van-tab name="props" title="道具"></van-tab>
                <van-tab name="role" title="角色"></van-tab>
            </van-tabs>
            <div class="list">
                <market-scroll url="index/apps" :params="{otype}" :keywords="keywords" method="get" ref="apps" @on-fetch="fetch">
                    <template slot-scope="scope">
                        <div class="game_box" v-for="(item,i) in scope.data" @click="gotoHome(item.app_name,item.icon,item.id,item.prop_trade,item.role_trade)" :ref="`market_`+ i">
                            <van-image class="icon" :src="item.icon"/>
                            <div class="info">
                                <p class="name">{{ item.app_name }}</p>
                                <p class="num">
                                    <span>共上架{{item.goods_cnt}}件商品</span>
                                    <span>已售<i>{{item.trade_cnt}}</i>件</span>
                                </p>
                            </div>
                            <div class="rz">
                                <img class="rz_icon" src="../../assets/version_1.3.0/market/rz.png" alt="">
                                <span v-if="item.prop_trade == 1">道具</span>
                                <span :class="{'bl': item.prop_trade == 1}" v-if="item.role_trade == 1">角色</span>
                            </div>
                        </div>
                    </template>
                </market-scroll>
            </div>
        </div>
    </div>
</template>

<script>
    import "swiper/dist/css/swiper.css";
    import {
        swiper,
        swiperSlide
    } from "vue-awesome-swiper";
    export default {
        props: ['showJc'],
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                active: 'all',
                // 搜索相关
                inputValue: "",
                keywords: '',
                showclear: false,
                //搜索 end

                swiperOption: {
                    slidesPerView: "auto",
                    freeMode: true, // 随意拖动位置
                    mousewheel: false,
                },
                bindapps: [],
            }
        },
        computed: {
            isLogin() {
                return this.$store.getters.isLogin;
            },
            otype() {
                return this.$store.state.market_otype
            },
            isiOS() {
                return /iphone|ipod|ipad/.test(navigator.userAgent.toLowerCase())
            }
        },
        created() {},
        mounted() {
            
        },
        activated() {
            if(this.isLogin) {
                this.getBindApps()
            }
        },
        methods: {
            //前往交易市场
            gotoHome(name, icon, id,prop_trade,role_trade) {
                this.$store.commit('resetServer')
                this.$store.commit('resetHomeServer')
                this.$store.commit('setGameInfo', {
                    name,
                    icon,
                    id
                })
                
                this.$store.commit('setCt','')
                this.$store.commit('setCi','')
                this.$store.commit('setCt2','')
                this.$store.commit('setCi2','')
                //道具市场 角色市场判断
                this.$store.commit('setHome',{prop_trade,role_trade})
                if(prop_trade == 0) {
                    this.$store.commit('changeHome',2)
                }else {
                    this.$store.commit('changeHome',1)
                }
                //角色市场 筛选全部重置
                this.$store.commit('resetAccPx')

                if(this.isiOS) {
                    window.location.href = window.location.origin + '/home?id=' + id
                }else {
                    this.$router.push({name: 'home',
                        query: {
                            id: id
                        }
                    })
                }
            },
            //搜索相关
            cleaript() {
                this.$refs.search_ipt.focus()
                this.inputValue = ''
            },
            getSearch() {
                if (this.inputValue == "") {
                    this.keywords = ''
                } else {
                    this.keywords = this.inputValue
                }
                this.$refs.apps.refresh()
            },
            //搜索end

            //常用app
            getBindApps() {
                this.$Ajax('index/bind-apps', {}, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.bindapps = rs.data
                    }
                })
            },
            //切换tab
            changeTab(name) {
                this.keywords = this.inputValue = ''
                if(name == 'all') {
                    this.$store.commit('setMarketOtype','')
                }else if(name == 'props'){
                    this.$store.commit('setMarketOtype',1)
                }else if(name == 'role'){
                    this.$store.commit('setMarketOtype',2)
                }
            },
            fetch(e) {
                if(this.showJc) {
                    setTimeout(() => {
                        var top = this.$refs['market_0'][0].offsetTop
                        this.$emit('changeJc',{
                            top,
                            ...e
                        })
                    },500)
                }
            }
        },
        watch: {
            inputValue: {
                immediate: true,
                handler(e) {
                    if (e != '') {
                        this.showclear = true
                    } else {
                        this.showclear = false
                    }
                }
            },
            otype:{
                immediate: true,
                handler(e) {
                    if(e == '') {
                        this.active = 'all'
                    }else if(e == 1){
                        this.active = 'props'
                    }else if(e == 2){
                        this.active = 'role'
                    }
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .header {
        width: 100%;
        height: 7.4rem;
        position: fixed;
        top: 0;
        left: 50%;
        width: 100%;
        padding: 2rem 1rem 1rem;
        max-width: 525px;
        z-index: 100;
        transform: translateX(-50%);
        text-align: center;
        overflow: hidden;
        background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        background-color: #fff;

        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1rem;
            background-color: #fff;
            border-top-left-radius: .5rem;
            border-top-right-radius: .5rem;
        }

        .header-inner {
            display: flex;
            align-items: center;
            position: relative;

            .left-icon {
                color: #ffff;
                font-size: 2rem;
                margin-right: .9rem;
                cursor: pointer;
            }

            .search {
                flex: 1;
                height: 3.4rem;
                background-color: #fff;
                border-radius: 10rem;
                overflow: hidden;
                position: relative;

                .van-swipe {
                    width: 15rem;

                    .van-swipe-item {
                        padding-top: 0.8rem;
                        font-size: 1.4rem;
                        color: #999;
                        text-align: left;
                        padding-left: 1.5rem;
                    }
                }

                .search_ipt {
                    position: absolute;
                    height: 100%;
                    line-height: 3.4rem;
                    width: 27rem;
                    left: 0;
                    top: 0;
                    border: none;
                    outline: none;
                    background-color: transparent;
                    padding: 0 1.5rem;
                    font-size: 1.4rem;
                    color: #000;

                    &::placeholder {
                        color: #999;
                    }
                }

                .clear {
                    position: absolute;
                    right: 6.2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1.4rem;
                    height: 1.4rem;
                    border-radius: 50%;
                    background-color: #a4a4a4;
                    cursor: pointer;

                    &::before,
                    &::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 1rem;
                        height: .1rem;
                        background-color: #fff;
                    }

                    &::before {
                        transform: translate(-50%, -50%) rotate(45deg);
                    }

                    &::after {
                        transform: translate(-50%, -50%) rotate(-45deg);
                    }
                }

                .search_btn {
                    position: absolute;
                    right: .5rem;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 5.3rem;
                    height: 2.6rem;
                    line-height: 2.6rem;
                    background-color: #f66f30;
                    border-radius: 10rem;
                    color: #fff;
                    font-size: 1.4rem;
                    border: none;
                    outline: none;

                    &:active {
                        opacity: 0.9;
                    }
                }
            }

        }
    }

    .market_area {
        padding-top: 7.4rem;
    }
    .common {
        padding-bottom: 1rem;
        border-bottom: 1px solid #e9e9e9;
        .tit {
            font-size: 1.4rem;
            color: #040404;
            font-weight: 700;
            margin-bottom: 1.1rem;
        }
        .swiper-slide  {
            width: 6rem;
            margin-right: 1.4rem;
            &:nth-last-child(1) {
                margin-left: 0;
            }
        }
        .common_swiper_item {
            width: 6rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            .icon {
                width: 6rem;
                height: 6rem;
                border-radius: 1rem;
                overflow: hidden;
                margin-bottom: 1rem;
            }
            p {
                font-size: 1.2rem;
                color: #606060;
                width: 6rem;
                text-align: center;
                overflow: hidden;
                line-height: 1.2;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }
    
    .van-tabs {
        background-color: #fff;
        position: sticky;
        top: 7.4rem;
        z-index: 10;
        /deep/.van-tabs__wrap {
            height: 3.2rem;
        }
        /deep/.van-tab {
            flex: unset;
            margin-right: 3.2rem;
            font-size: 1.4rem;
            color: #555;
            align-items: flex-end;
            padding-bottom: 0.4rem;
            &.van-tab--active {
                color: #F66F30;
                font-weight: 700;
            }
        }
        /deep/.van-tabs__nav--line {
            padding-bottom: 0;
        }
        /deep/.van-tabs__line {
            background-color: #f66f30;
            bottom: 0;
            height: .2rem;
        }
    }
    .list {
        padding: 1rem 0;
    }
    .game_box {
        display: flex;
        padding: 1.2rem 0;
        border-top: 1px solid #e9e9e9;
        cursor: pointer;
        &:nth-child(1) {
            border: none;
        }
        .icon {
            width: 5.2rem;
            height: 5.2rem;
            border-radius: 1rem;
            overflow: hidden;
            margin-right: .8rem;
        }
        .info {
            flex: 1;
            padding: 0.4rem 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
                font-size: 1.4rem;
                color: #000;
            }
            .num {
                display: flex;
                justify-content: space-between;
                color: #929292;
                font-size: 1.2rem;
                i {
                   color: #FF5E5E; 
                }
                span:nth-last-child(1) {
                    width: 6rem;
                    text-align: start;
                    white-space: nowrap;
                }
            }
        }
        .rz {
            margin-left: 2rem;
            padding-bottom: .4rem;
            width: 7.8rem;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            font-size: 1.2rem;
            color: #929292;
            .rz_icon {
                width: 1.2rem;
                height: 1.2rem;
                margin-right: .5rem;
                transform: translateY(-0.2rem);
            }
            .bl {
                padding-left: 0.5rem;
                margin-left: 0.5rem;
                position: relative;
                &::before {
                    content: '';
                    width: 1px;
                    height: 1.2rem;
                    background-color: #929292;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
    .fixed_page {
        width: calc(100% - 2.4rem);
        max-width: calc(525px - 2.4rem);
    }
</style>